import { ApplicationPageType } from '../AccountTabNav';
import AccountTabPage from '../Page/AccountTabPage';

export default function NotesPage() {
  return (
    <AccountTabPage
      page={ApplicationPageType.NOTES}
    >
      <></>
    </AccountTabPage>
  );
}
